var Vue = require('vue');
var picturefill = require('picturefill');
var TestimonyTemplate = require('./components/molecules/testimony.vue');
var contactPersonShape = require('./components/molecules/contact-person-shape.vue');
var ContactMap = require('./components/molecules/contact-map.vue');
var AboutProjects = require('./components/molecules/about-projects.vue');
var Award = require('./components/molecules/award.vue');
var ProjectList = require('./components/organisms/project-list.vue');
var AwardsSlider = require('./components/organisms/awards-slider.vue');
var Project = require('./components/molecules/project.vue');
var ObjectDescription= require('./components/molecules/object-description.vue');
var ProjectSlider = require('./components/organisms/project-slider.vue');
var BuildingStageSlider = require('./components/organisms/building-stage-slider.vue');
var TeamMembers = require('./components/organisms/team-members.vue');
var ProjectAwardsSlider = require('./components/organisms/project-awards-slider.vue');
var sectorShape = require('./components/molecules/sector-shape.vue');

var $ = require('jquery');
var Headroom = require('headroom.js');
var slick = require('slick-carousel-browserify');

/*polyfill for responsive imgs*/
picturefill();

Vue.component('contact-person-shape', contactPersonShape);
Vue.component('testimony', TestimonyTemplate);
Vue.component('about-projects', AboutProjects);
Vue.component('project-list', ProjectList);
Vue.component('awards-slider', AwardsSlider);
Vue.component('award-item', Award);
Vue.component('team-members', TeamMembers);
Vue.component('contact-map', ContactMap);
Vue.component('project', Project);
Vue.component('object-description', ObjectDescription);
Vue.component('project-slider', ProjectSlider);
Vue.component('building-stage-slider', BuildingStageSlider);
Vue.component('project-awards-slider', ProjectAwardsSlider);
Vue.component('sector-shape', sectorShape);

var vm = new Vue({
    el: '#ovo-app',
    data: {
        nav_open: false,
        /*footer requisites toggle*/
        requisites_open: false
    },
    ready: function () {
        "use strict";
        //project slider component listens to this event
        this.$broadcast('my_body_is_ready');
    }
});

// -------------------------------------
//   Show's / hide's mobile navigation
//   on scroll up or down
// -------------------------------------

var mobile_nav = document.getElementById("mobile-nav");
if(mobile_nav) {

    var headroom = new Headroom(mobile_nav, {
        "offset": 20,
        "tolerance": 5,
        "classes": {
            "initial": "animated",
            "pinned": "animated--swing-in",
            "unpinned": "animated--swing-out"
        }
    });

    headroom.init();
}
// this is only for object with decimal number
var $projectDef = $(".project-data__definition");

if ($projectDef) {
    $.each($projectDef, function () {
        var $this = $(this);
        $this.text();
        if (!isNaN(Number($this.text()))) {
            $this.append( " m <sup>2</sup>" );
        }
    });
}


// detects ios device and call function which avoid from double click on button which has hover
var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (iOS) {
    $(".button").on("touchend", iosTapOnce);
}

function iosTapOnce() {
    $(this).trigger("click");
}